function t(t,e){return t instanceof Date?new t.constructor(e):new Date(e)}export{t as constructFrom,t as default};
//# sourceMappingURL=constructFrom.js.map
